import "../styles/main.css";

import { initMenu } from "../behaviors/menu.js";
import { initStickyHeader } from "../behaviors/sticky-header.js";
import { initSmoothScroll } from "../behaviors/smooth-scroll.js";
import { mountGallery } from "../islands/gallery.js";
import { initMetrika } from "../behaviors/metrika.js";
import { initSocialLinks } from "../behaviors/social-links.js";
import { initCopyButtons } from "../behaviors/copy-button.js";

function init() {
  initMenu();
  initStickyHeader();
  initSmoothScroll();
  mountGallery();
  initMetrika();
  initSocialLinks();
  initCopyButtons();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
